/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import mbpLogger from '@module-logger/mbp';
import {
    object,
} from 'prop-types';

import { usePrev } from '../../../helpers/hooks/usePrev';

const ErrorPage = (props) => {
    const {
        errors,
    } = props;
    const { errorMessage, isErrorResponse, component } = errors;

    const prevError = usePrev(isErrorResponse);
    useEffect(() => {
        if (prevError !== isErrorResponse) {
            mbpLogger.logError({
                component,
                message: `${component} - ${errorMessage}`,
                isErrorResponse,
                module: 'mbp-pwa-ui',
            });
        }
    }, [isErrorResponse]);

    return (
        <div className="align-center">
            <div className="oops-wrapper">
                <img src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/blt91127120f3d66c9b/607be57feea64578d07fc8c1/Hazard_Oops_Icon.svg" alt="Hazard Oops Icon" />
                <p className="oops">Oops!</p>
                <p>Sorry, maintenance is in-progress.</p>
                <p>For immediate assistance, please click the CHAT icon.</p>
            </div>
        </div>
    );
};

ErrorPage.defaultProps = {
    errors: {},
};

ErrorPage.propTypes = {
    errors: object,
};

export default ErrorPage;
